/* This is generated code, don't alter */
var IfcElectricMotorTypeEnum;
(function (IfcElectricMotorTypeEnum) {
    IfcElectricMotorTypeEnum[IfcElectricMotorTypeEnum["DC"] = 0] = "DC";
    IfcElectricMotorTypeEnum[IfcElectricMotorTypeEnum["INDUCTION"] = 1] = "INDUCTION";
    IfcElectricMotorTypeEnum[IfcElectricMotorTypeEnum["POLYPHASE"] = 2] = "POLYPHASE";
    IfcElectricMotorTypeEnum[IfcElectricMotorTypeEnum["RELUCTANCESYNCHRONOUS"] = 3] = "RELUCTANCESYNCHRONOUS";
    IfcElectricMotorTypeEnum[IfcElectricMotorTypeEnum["SYNCHRONOUS"] = 4] = "SYNCHRONOUS";
    IfcElectricMotorTypeEnum[IfcElectricMotorTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcElectricMotorTypeEnum[IfcElectricMotorTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcElectricMotorTypeEnum || (IfcElectricMotorTypeEnum = {}));
const IfcElectricMotorTypeEnumCount = 7;
export { IfcElectricMotorTypeEnum, IfcElectricMotorTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcElectricMotorTypeEnum = new Int32Array([57]);
let prefixSumAddressIfcElectricMotorTypeEnum = new Uint32Array([0, 12, 25, 38, 61, 72, 83, 87]);
let slotMapIfcElectricMotorTypeEnum = new Int32Array([6, 5, 4, 3, 1, 2, 0]);
let encodedDataIfcElectricMotorTypeEnum = (new TextEncoder()).encode(".NOTDEFINED..USERDEFINED..SYNCHRONOUS..RELUCTANCESYNCHRONOUS..INDUCTION..POLYPHASE..DC.");
let IfcElectricMotorTypeEnumSearch = new MinimalPerfectHash(gMapIfcElectricMotorTypeEnum, prefixSumAddressIfcElectricMotorTypeEnum, slotMapIfcElectricMotorTypeEnum, encodedDataIfcElectricMotorTypeEnum);
export { IfcElectricMotorTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcElectricMotorTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcElectricMotorTypeEnumSearch, input, cursor, endCursor);
}
